import React from 'react';
import { ContainerComponent, wrap, today } from 'AppReact';
import Controller from './controller'
import { format, isBefore, isSameDay } from 'date-fns';
import { MakeReadyDateCellWrapper, AbsoluteLeftTopWrapper, UnderlineDecoration, Mr2, Td, RelativeWrapper, Ml2, TooltipWrapper } from 'wrappers';
import { Icon, SecondaryTextXs, RedTextXs, Tooltip, Empty } from 'atoms';
import { Calendar } from 'containers';
import { MoveInSvg, MoveOutSvg, TickSvg, GreenTickSvg, ExclamationMarkSvg } from 'components/icons';
import internalState from './internalState';
import wrapTooltip from 'wrappers/tooltip'

const containerRef = React.createRef();

export const definition = {
  name: 'DateCell',
  controller: Controller,
  initialProps: ({ selectedDate, type, showCheckMark }) => ({ selectedDate, type, showCheckMark }),
  props: internalState,
  elements: [
    {
      wrapper: MakeReadyDateCellWrapper,
      name: 'ImmutableDate',
      renderIf: ({ type }) => type === 'move-in' || type === 'move-out',
      displayState: ({ }) => ({ disabled: true }),
      elements: [
        {
          component: wrap(Icon, Mr2),
          name: 'Icon',
          displayValue: ({ type }) => type === 'move-in' ? MoveOutSvg({ color: '#FFC700', width: '13px', height: '13px' }) : MoveInSvg({ color: '#FFC700', width: '13px', height: '13px' })
        },
        {
          wrapper: TooltipWrapper,
          name: 'Date',
          renderIf: ({ showCheckMark }) => showCheckMark,
          elements: [
            {
              component: Empty,
              name: 'Icon',
              displayValue: ({ }) => GreenTickSvg({ color: '#04333b' })
            },
            {
              component: Tooltip,
              name: 'Popup',
              displayValue: ({ selectedDate }) => selectedDate ? format(selectedDate, 'MM/dd') : 'Unknown date'
            }
          ]
        },
        {
          component: SecondaryTextXs,
          name: 'Date',
          renderIf: ({ selectedDate, showCheckMark }) => !!selectedDate && !showCheckMark && !(isSameDay(selectedDate, today()) || isBefore(selectedDate, today())),
          displayValue: ({ selectedDate }) => format(selectedDate, 'MM/dd'),
        },
        {
          component: RedTextXs,
          name: 'Date',
          renderIf: ({ selectedDate, showCheckMark }) => !!selectedDate && !showCheckMark && (isSameDay(selectedDate, today()) || isBefore(selectedDate, today())),
          displayValue: ({ selectedDate }) => format(selectedDate, 'MM/dd'),
        },
        {
          component: wrap(SecondaryTextXs, Ml2),
          name: 'Add',
          renderIf: ({ selectedDate, showCheckMark, type }) => !selectedDate && !showCheckMark && type !== 'move-out',
          displayValue: ({ }) => '-',
        },
        wrapTooltip({
          component: Icon,
          tooltip: { content: 'Move out date missing from PMS', direction: 'right' },
          name: 'Date',
          renderIf: ({ selectedDate, showCheckMark, type }) => !selectedDate && !showCheckMark && type === 'move-out',
          displayValue: ({ }) => ExclamationMarkSvg({}),
        })
      ]
    },
    {
      wrapper: MakeReadyDateCellWrapper,
      name: 'Selector',
      isButton: true,
      renderIf: ({ type }) => type !== 'move-in' && type !== 'move-out',
      bindings: ({ isOpen }) => ({ containerRef, isOpen, disabled: window.settings?.use_integration_for_make_ready_date }),
      displayState: ({ isOpen, selectedDate }) => ({ translucid: !selectedDate && !isOpen, disabled: window.settings?.use_integration_for_make_ready_date }),
      elements: [
        {
          component: wrap(Icon, Mr2),
          name: 'Icon',
          displayValue: ({ type }) => type === 'move-in' ? MoveOutSvg({ color: '#FFC700', width: '13px', height: '13px' }) :
            type === 'move-out' ? MoveInSvg({ color: '#FFC700', width: '13px', height: '13px' }) :
              TickSvg({ square: true, color: '#1DBD6B', width: '13px', height: '13px' })
        },
        {
          wrapper: TooltipWrapper,
          name: 'Date',
          renderIf: ({ showCheckMark }) => showCheckMark,
          elements: [
            {
              component: Empty,
              name: 'Icon',
              displayValue: ({ }) => GreenTickSvg({ color: '#04333b' })
            },
            {
              component: Tooltip,
              name: 'Popup',
              displayValue: ({ selectedDate }) => selectedDate ? format(selectedDate, 'MM/dd') : 'Unknown date'
            }
          ]
        },
        {
          component: SecondaryTextXs,
          name: 'Date',
          renderIf: ({ selectedDate, showCheckMark }) => !!selectedDate && !showCheckMark && !(isSameDay(selectedDate, today()) || isBefore(selectedDate, today())),
          displayValue: ({ selectedDate }) => format(selectedDate, 'MM/dd'),
        },
        {
          component: RedTextXs,
          name: 'Date',
          renderIf: ({ selectedDate, showCheckMark }) => !!selectedDate && !showCheckMark && (isSameDay(selectedDate, today()) || isBefore(selectedDate, today())),
          displayValue: ({ selectedDate }) => format(selectedDate, 'MM/dd'),
        },
        {
          component: wrap(SecondaryTextXs, UnderlineDecoration),
          name: 'Add',
          renderIf: ({ selectedDate, showCheckMark }) => !selectedDate && !showCheckMark,
          displayValue: ({ }) => 'Add',
        }
      ]
    },
    {
      wrapper: AbsoluteLeftTopWrapper,
      name: "CalendarWrapper",
      displayState: ({ }) => ({ top: '54px' }),
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: Calendar,
          name: 'Calendar',
          bindings: ({ selectedDate, type }) => {
            const month = selectedDate?.getMonth?.() || 5
            const year = selectedDate?.getFullYear?.() || 2020
            return { selectedDate, month, year, disabledBefore: type === 'move-out' ? null : today(), hasRemove: type !== 'move-out' }
          }
        }
      ]
    }
  ]
}

export default wrap(wrap(ContainerComponent(definition), RelativeWrapper), Td);